import { Button } from "@mui/material";
import "./manage-revenue.scss";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import GroupsIcon from "@mui/icons-material/Groups";
import NorthEastIcon from '@mui/icons-material/NorthEast';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from "react-router-dom";
import {
    ResponsiveContainer,
    BarChart,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Bar,
    LineChart,
    Line,
    AreaChart,
    Area,
} from "recharts";

const customerData = [
    { name: "Mon", customers: 40 },
    { name: "Tue", customers: 65 },
    { name: "Wed", customers: 52 },
    { name: "Thu", customers: 80 },
    { name: "Fri", customers: 70 },
    { name: "Sat", customers: 45 },
    { name: "Sun", customers: 50 },
];

// Sample order data (per month)
const orderData = [
    { name: "Jan", orders: 120 },
    { name: "Feb", orders: 150 },
    { name: "Mar", orders: 170 },
    { name: "Apr", orders: 190 },
    { name: "May", orders: 210 },
    { name: "Jun", orders: 250 },
    { name: "Jul", orders: 280 },
];

// Sample cancelled orders data (per month)
const cancelledOrdersData = [
    { name: "Jan", cancelled: 5 },
    { name: "Feb", cancelled: 3 },
    { name: "Mar", cancelled: 7 },
    { name: "Apr", cancelled: 2 },
    { name: "May", cancelled: 4 },
    { name: "Jun", cancelled: 6 },
    { name: "Jul", cancelled: 3 },
];

const heatmapData = [
    [20, 30, 40, 50, 60, 70, 80],
    [10, 20, 30, 40, 50, 60, 70],
    [5, 10, 15, 20, 25, 30, 35],
    [2, 4, 6, 8, 10, 12, 14],
];

const revenueTrendData = [
    { name: "Jun", revenue: 80 },
    { name: "Feb", revenue: 130 },
    { name: "Mar", revenue: 160 },
    { name: "Apr", revenue: 180 },
    { name: "May", revenue: 210 },
    { name: "Jun", revenue: 240 },
    { name: "Jul", revenue: 270 },
    { name: "Aug", revenue: 320 },
    { name: "Jul", revenue: 290 },
];

const categoryData = [
    { name: "Fashion", revenue: 570 },
    { name: "Home Decor", revenue: 890 },
    { name: "Handmade", revenue: 1400 },
    { name: "Wellness", revenue: 950 },
];

const cancellationTrendData = [
    { name: "Jan", cancellations: 300, refunds: 250, forecast: 400, optimal: 500 },
    { name: "Feb", cancellations: 450, refunds: 380, forecast: 550, optimal: 700 },
    { name: "Mar", cancellations: 520, refunds: 480, forecast: 750, optimal: 950 },
    { name: "Apr", cancellations: 680, refunds: 600, forecast: 950, optimal: 1200 },
    { name: "May", cancellations: 850, refunds: 780, forecast: 1150, optimal: 1500 },
    { name: "Jun", cancellations: 950, refunds: 900, forecast: 1450, optimal: 1900 },
    { name: "Jul", cancellations: 1100, refunds: 1050, forecast: 1800, optimal: 2400 },
];


const Revenue = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="main_title">
                <h1>Revenue</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Revenue Analytics
                </p>
            </div>
            <div className="stats_boxes gap_m mb_20">
                {/* CARD 1 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            AED 1.82M
                            <p>MTD</p>
                        </h2>
                        <figure className="active_order">
                            <CurrencyExchangeIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <span>+18% vs last month</span>
                        <span className="badge">+14%</span>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            <NorthEastIcon sx={{ color: '#22c55e', verticalAlign: 'middle', mr: 0.5 }} /> 4.6%
                            <p>Run Rate</p>
                        </h2>
                        <figure className="sucess">
                            <TrendingUpIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                        <span>+130k new 6-month</span>
                        <small>+130M mrr month</small>
                    </div>
                </div>

                {/* CARD 3 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            2141
                            <p>ABV</p>
                        </h2>
                        <figure className="warning">
                            <AccountBalanceWalletIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <span>+3.9% vs last month</span>
                        <span className="badge">+4%</span>
                    </div>
                </div>

                {/* CARD 4 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            28.2%
                            <p>Retention</p>
                        </h2>
                        <figure className="info">
                            <GroupsIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <span>+1.5% vs last month</span>
                        <span className="badge">14%</span>
                    </div>
                </div>
            </div>

            <div className="table_flex">
                <div className="lt">

                    <div className="table_header mb_20">
                        <div className="left_s">
                            <h2>Revenue Analytics</h2>
                        </div>
                        <div className="right_s form gap_10">
                            <div className="d_flex gap_5">
                                <Button className="btn btn_grey sm active" sx={{ backgroundColor: '#F0E6D2 !important', color: '#8B6B4C !important' }}>Daily</Button>
                                <Button className="btn btn_grey sm">Weekly</Button>
                                <Button className="btn btn_grey sm">Monthly</Button>
                                <Button className="btn btn_grey sm">Yearly</Button>
                            </div>
                          
                        </div>
                    </div>

                    <div className="grid_sc gap_m">
                        {/* Daily Revenue Heatmap */}
                        <div className="cards table_card">
                            <div className="cards_header">
                                <div className="left_s">
                                    <h2>Daily Revenue Heatmap</h2>
                                </div>
                                <div className="right_s">
                                    <small style={{ color: '#8B6B4C' }}>AED</small>
                                </div>
                            </div>

                            <div className="heatmap_container">
                                <div className="heatmap_y_axis">
                                    <span>80</span>
                                    <span>60</span>
                                    <span>40</span>
                                    <span>20</span>
                                </div>
                                <div className="heatmap_grid">
                                    {heatmapData.map((row, rIdx) => (
                                        <div key={rIdx} className="heatmap_row">
                                            {row.map((val, cIdx) => {
                                                const opacity = val / 80;
                                                return (
                                                    <div
                                                        key={cIdx}
                                                        className="heatmap_cell"
                                                        style={{ backgroundColor: `rgba(139, 107, 76, ${opacity})` }}
                                                    />
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="heatmap_x_axis">
                                <span>Mon</span>
                                <span>Tue</span>
                                <span>Wed</span>
                                <span>Thu</span>
                                <span>Fri</span>
                                <span>Sat</span>
                                <span>Sun</span>
                            </div>
                            <div className="heatmap_footer mt_15">
                                <p style={{ fontSize: '11px', color: '#666', borderTop: '1px dashed #ddd', paddingTop: '10px' }}>* On average, Thursday 9-10 PM yields the highest revs.</p>
                            </div>
                        </div>

                        {/* Monthly Revenue Trend */}
                        <div className="cards table_card">
                            <div className="cards_header">
                                <div className="left_s">
                                    <h2>Monthly Revenue Trend</h2>
                                </div>
                          
                            </div>
                            <ResponsiveContainer width="100%" height={300}>
                                <AreaChart data={revenueTrendData}>
                                    <defs>
                                        <linearGradient id="colorRev" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#D3B88C" stopOpacity={0.8} />
                                            <stop offset="95%" stopColor="#D3B88C" stopOpacity={0} />
                                        </linearGradient>
                                    </defs>
                                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                    <XAxis dataKey="name" axisLine={false} tickLine={false} />
                                    <YAxis axisLine={false} tickLine={false} tickFormatter={(val) => `${val} K`} />
                                    <Tooltip />
                                    <Area
                                        type="monotone"
                                        dataKey="revenue"
                                        stroke="#8B6B4C"
                                        fillOpacity={1}
                                        fill="url(#colorRev)"
                                        strokeWidth={2}
                                        dot={{ fill: '#8B6B4C', strokeWidth: 2, r: 4 }}
                                        activeDot={{ r: 6 }}
                                    />
                                </AreaChart>
                            </ResponsiveContainer>
                        </div>
                    </div>

                    {/* Row 2: Category, Cancellations, Forecast */}
                    <div className="grid_sc_3 gap_m mt_20">
                        {/* Revenue by Category */}
                        <div className="cards table_card">
                            <div className="cards_header">
                                <div className="left_s">
                                    <h2>Revenue by Category</h2>
                                    <p style={{ fontSize: '11px', color: '#666' }}>✓ Fashion</p>
                                </div>
                                <div className="right_s">
                                    <span className="d_flex align-center gap_5" style={{ color: '#D3B88C', fontSize: '12px' }}>
                                        <div style={{ width: 10, height: 10, backgroundColor: '#D3B88C', borderRadius: 2 }}></div> Revenue
                                    </span>
                                </div>
                            </div>
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart data={categoryData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                                    <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 10 }} />
                                    <YAxis axisLine={false} tickLine={false} tickFormatter={(val) => `${val} K`} tick={{ fontSize: 10 }} />
                                    <Tooltip />
                                    <Bar dataKey="revenue" fill="#D3B88C" radius={[4, 4, 0, 0]} barSize={40} />
                                </BarChart>
                            </ResponsiveContainer>
                            <div className="chart_legend_btm d_flex gap_15 mt_10">
                                <span className="d_flex align-center gap_5" style={{ fontSize: '11px' }}><CurrencyExchangeIcon sx={{ fontSize: 14, color: '#8B6B4C' }} /> Revenue</span>
                                <span className="d_flex align-center gap_5" style={{ fontSize: '11px' }}><TrendingUpIcon sx={{ fontSize: 14, color: '#8B6B4C' }} /> Orders</span>
                                <span className="d_flex align-center gap_5" style={{ fontSize: '11px' }}><AccountBalanceWalletIcon sx={{ fontSize: 14, color: '#8B6B4C' }} /> Refund amount</span>
                            </div>
                        </div>

                        {/* Cancellations & Refunds */}
                        <div className="cards table_card">
                            <div className="cards_header">
                                <div className="left_s">
                                    <h2>Cancellations & Refunds</h2>
                                    <div className="mt_5">
                                        <b style={{ fontSize: '14px' }}>374</b>
                                        <p style={{ fontSize: '10px', color: '#999', margin: 0 }}>Total</p>
                                    </div>
                                </div>
                                <div className="right_s">
                                    <div style={{ textAlign: 'right' }}>
                                        <b style={{ fontSize: '14px' }}>543K</b>
                                    </div>
                                </div>
                            </div>
                            <ResponsiveContainer width="100%" height={200}>
                                <LineChart data={cancellationTrendData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                                    <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 10 }} />
                                    <YAxis axisLine={false} tickLine={false} tickFormatter={(val) => `${val} K`} tick={{ fontSize: 10 }} />
                                    <Tooltip />
                                    <Line type="monotone" dataKey="cancellations" stroke="#8B6B4C" strokeWidth={2} dot={{ r: 3 }} />
                                    <Line type="monotone" dataKey="refunds" stroke="#D3B88C" strokeDasharray="5 5" strokeWidth={2} dot={{ r: 3 }} />
                                </LineChart>
                            </ResponsiveContainer>
                            <div className="impact_note d_flex align-center gap_5 mt_10" style={{ backgroundColor: '#F9F6F0', padding: '8px', borderRadius: '4px' }}>
                                <span style={{ fontSize: '11px' }}>Impacts now*</span>
                                <span className="badge success" style={{ fontSize: '10px', backgroundColor: '#E8F5E9', color: '#2E7D32', padding: '2px 6px', borderRadius: '10px' }}>
                                    <TrendingUpIcon sx={{ fontSize: 10, verticalAlign: 'middle', mr: 0.5 }} /> -33.68%
                                </span>
                                <span style={{ fontSize: '11px', color: '#666' }}>From AED 24K</span>
                            </div>
                        </div>

                        {/* Monthly Revenue Trend */}
                        <div className="cards table_card">
                            <div className="cards_header">
                                <div className="left_s">
                                    <h2>Monthly Revenue Trend</h2>
                                  
                                </div>
                              
                            </div>
                            <ResponsiveContainer width="100%" height={200}>
                                <AreaChart data={cancellationTrendData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                                    <defs>
                                        <linearGradient id="colorRev2" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#D3B88C" stopOpacity={0.6} />
                                            <stop offset="95%" stopColor="#D3B88C" stopOpacity={0} />
                                        </linearGradient>
                                    </defs>
                                    <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 10 }} />
                                    <YAxis axisLine={false} tickLine={false} tickFormatter={(val) => `${val} K`} tick={{ fontSize: 10 }} />
                                    <Tooltip />
                                    <Area
                                        type="monotone"
                                        dataKey="refunds"
                                        stroke="#8B6B4C"
                                        fillOpacity={1}
                                        fill="url(#colorRev2)"
                                        strokeWidth={2}
                                        dot={{ fill: '#8B6B4C', strokeWidth: 1, r: 3 }}
                                    />
                                </AreaChart>
                            </ResponsiveContainer>
                        </div>
                    </div>

                    {/* Row 3: Revenue Opportunities & Detailed Forecast */}
                    <div className="grid_sc gap_m mt_20">
                        {/* Detailed Revenue Forecast */}
                        <div className="cards" style={{ width: "calc(100% - 25px)" }}>
                            <div className="cards_header" style={{ marginBottom: '30px' }}>
                                <div className="left_s">
                                    <h2 style={{ fontSize: '20px', fontWeight: 600 }}>Revenue Forecast</h2>
                                </div>
                                <div className="right_s" style={{ textAlign: 'right' }}>
                                    <span style={{ fontSize: '11px', color: '#999', display: 'block' }}>+8% confidence</span>
                                    <span style={{ fontSize: '9px', backgroundColor: '#e8eef6', color: '#555', padding: '4px 8px', borderRadius: '15px', display: 'inline-block', marginTop: '5px' }}>
                                        98% confidence Risk levels
                                    </span>
                                </div>
                            </div>

                            <div className="forecast_chart_v2">
                                <div className="mb_20">
                                    <b style={{ fontSize: '18px', display: 'block' }}>AED 2.4M</b>
                                    <span style={{ fontSize: '11px', color: '#aaa' }}>Optimal Revenue by month</span>

                                    <div className="d_flex align-center gap_10 mt_10">
                                        <span className="badge positive" style={{ backgroundColor: '#E8F5E9', color: '#2E7D32', fontSize: '11px', padding: '2px 6px' }}>+AED 24K</span>
                                    </div>

                                    <div className="mt_10">
                                        <span style={{ fontSize: '13px', fontWeight: 600 }}>AED 2.1M</span>
                                        <span className="ml_5" style={{ fontSize: '9px', backgroundColor: '#FFF3E0', color: '#E65100', padding: '2px 4px', borderRadius: '3px' }}>High</span>
                                        <span className="ml_5" style={{ fontSize: '11px', color: '#999' }}>98% impact</span>
                                    </div>
                                </div>

                                <ResponsiveContainer width="100%" height={150}>
                                    <LineChart data={cancellationTrendData} margin={{ top: 5, right: 10, left: 10, bottom: 0 }}>
                                        <Tooltip />
                                        <Line type="monotone" dataKey="optimal" stroke="#8B6B4C" strokeWidth={3} dot={{ r: 4, fill: '#8B6B4C' }} />
                                        <Line type="monotone" dataKey="forecast" stroke="#D3B88C" strokeDasharray="5 5" strokeWidth={2} dot={false} />
                                    </LineChart>
                                </ResponsiveContainer>
                                {/* Performance Footer Strip */}
                                <div className="revenue_footer_strip ">
                                    <div className="d_flex gap_20 align-center">
                                        <div className="nav_arrows d_flex align-center gap_5">
                                            <DoubleArrowIcon className="back_arrow" />
                                            <KeyboardArrowLeftIcon />
                                        </div>

                                        <div className="metric_group">
                                            <span className="label">
                                                <b>$4 - 7.7</b>
                                            </span>
                                            <span className="value_badge">
                                                3.34
                                            </span>
                                        </div>

                                        <div className="divider"></div>

                                        <div className="metric_group">
                                            <span className="secondary_value">
                                                32 <NorthEastIcon /> 7.7
                                            </span>
                                            <span className="percentage">91%</span>
                                        </div>
                                    </div>

                                    <div className="metric_group">
                                        <span className="insight">
                                            8.5% aggsssets (980% - 908%)
                                        </span>
                                        <div className="nav_single">
                                            <DoubleArrowIcon />
                                        </div>
                                    </div>

                                    <div className="chevron_nav d_flex gap_5 align-center">
                                        <ChevronLeftIcon />
                                        <ChevronRightIcon />
                                    </div>
                                </div>
                            </div>

                            {/* Performance Footer Strip */}

                        </div>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel d_flex gap_20 overflow-x-auto pb_10">
                        <div
                            className="ai_alert success flex-grow-1"
                            style={{ minWidth: "300px" }}
                        >
                            <div className="d_flex align-center">
                                <span className="icon">🚀</span>
                                <p>
                                    <b>High-Growth Alert:</b> 12 Vendors in 'Pro' hitting 90% AI
                                    limits.
                                    <Button
                                        size="small"
                                        variant="text"
                                        sx={{ ml: 1, textTransform: "none" }}
                                    >
                                        Bulk Upgrade
                                    </Button>
                                </p>
                            </div>
                        </div>

                        <div
                            className="ai_alert danger flex-grow-1"
                            style={{ minWidth: "300px" }}
                        >
                            <div className="d_flex align-center">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>Churn Risk:</b> 5 Enterprise vendors inactive for 14+
                                    days.
                                    <Button
                                        size="small"
                                        variant="text"
                                        sx={{ ml: 1, textTransform: "none" }}
                                    >
                                        View List
                                    </Button>
                                </p>
                            </div>
                        </div>

                        <div
                            className="ai_alert warning flex-grow-1"
                            style={{ minWidth: "300px" }}
                        >
                            <div className="d_flex align-center">
                                <span className="icon">💡</span>
                                <p>
                                    <b>Optimization:</b> "Scale+" segment has 40% higher GMV.
                                    <Button
                                        size="small"
                                        variant="text"
                                        sx={{ ml: 1, textTransform: "none" }}
                                    >
                                        Compare Plans
                                    </Button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Revenue;
